import React, { FC } from 'react';
import AboutUsBase from './index.base';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import MainLayoutMobile from 'layouts/main-layout/main-layout.mobile';
import Container from 'atomic/container';

const AboutUsMobile: FC = () => (
    <MainLayoutMobile
        disableAdSlots={true}
    >
        <Container>
            <AboutUsBase />
        </Container>
    </MainLayoutMobile>
);

export default withFullHydrate(AboutUsMobile, { root: '#root' }, 'views/pages/static-pages/about-us/index.mobile');
